import { Dropdown, Menu } from 'antd'
import StyledLoader from 'components/Elements/StyledLoader'
import StyledTooltip from 'components/Elements/StyledTooltip'
import SectionTitle from 'components/SectionTitle'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useState } from 'react'
import { Accordion } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { FaBars } from 'react-icons/fa'
import { MdHelp, MdPersonAdd } from 'react-icons/md'
import 'react-quill/dist/quill.snow.css'
import { useHistory, useParams } from 'react-router-dom'
import FriendRow from 'sections/Dashboard/components/FriendRow'
import RoleEditModal from 'sections/Dashboard/components/RoleEditModal'
import { HELP_DESK, ROLES } from 'services/constants'
import { useBookRoleQuery, useBookUsersQuery } from 'store/queries'
import { colors } from 'style'
import { FriendsContainer } from './style'

function Friends() {
  const { lang } = useContext(DataContext)
  const { t } = useTranslation()
  const { bookId } = useParams()
  const history = useHistory()

  const { data: users } = useBookUsersQuery(bookId)
  const { data: role } = useBookRoleQuery(bookId)

  const [editingFriendRole, setEditingFriendRole] = useState({})

  const userRole = role?.name
  // TODO: Refactor
  const roleOptions = JSON.parse(JSON.stringify(ROLES))
  if (userRole === 'Purchaser') {
    delete roleOptions['purchaser']
    delete roleOptions['none']
  } else if (role?.name === 'Editor') {
    delete roleOptions['purchaser']
    delete roleOptions['editor']
    delete roleOptions['none']
  }

  const handleEditRole = (friend) => {
    setEditingFriendRole(friend)
  }

  const menu = (
    <Menu>
      <Menu.Item key="0">
        <span onClick={() => history.push(`/dashboard/book/${bookId}/add`)}>
          Add Friends
        </span>
      </Menu.Item>
      <Menu.Item key="1">
        <a
          href={HELP_DESK['friend_family'][lang]}
          target="_blank"
          rel="noreferrer"
        >
          Help
        </a>
      </Menu.Item>
    </Menu>
  )

  return (
    <FriendsContainer id="friends-section" className="section-container">
      <Accordion activeKey="0" className="accordion-friend">
        <Accordion.Item eventKey="0">
          <Accordion.Header
            as={'div'}
            className="accordion-toggler px-3 friends-section bb-line"
          >
            <div className="toggler-header">
              <SectionTitle className="mr-auto">
                {t('friends_and_family')}
              </SectionTitle>

              {(role?.name === 'Purchaser' ||
                role?.name === 'Editor' ||
                role?.name === 'Author') && (
                <div
                  id="add-user-btn"
                  className="icon-filter header-icon d-none d-md-flex cursor"
                  onClick={() =>
                    history.push(`/dashboard/book/${bookId}/friends/add`)
                  }
                >
                  <StyledTooltip title={t('tt_add_new_users')} placement="top">
                    <MdPersonAdd
                      color={colors.dark7}
                      size={30}
                      className="cursor icon-option"
                      data-testid="add-user-btn"
                    />
                  </StyledTooltip>
                </div>
              )}
              <div className="icon-question header-icon d-none d-md-flex">
                <a
                  href={HELP_DESK['friend_family'][lang]}
                  target="_blank"
                  rel="noreferrer"
                >
                  <StyledTooltip
                    title={t('tt_friend_family_help')}
                    placement="top"
                  >
                    <MdHelp
                      color={colors.dark7}
                      size={30}
                      className="cursor icon-option"
                    />
                  </StyledTooltip>
                </a>
              </div>

              <Dropdown overlay={menu} trigger={['click']}>
                <FaBars
                  className="d-md-none ant-dropdown-link"
                  size={32}
                  onClick={(e) => e.preventDefault()}
                />
              </Dropdown>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            {!role?.name ? (
              <StyledLoader isglobal={false} />
            ) : (
              <>
                {users?.map((friend, i) => (
                  <FriendRow
                    key={friend.id}
                    friend={friend}
                    index={i}
                    onEditRow={() => handleEditRole(friend)}
                  />
                ))}
              </>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <RoleEditModal
        open={editingFriendRole?.role_id}
        onClose={() => setEditingFriendRole({})}
        friend={editingFriendRole}
        roleOptions={roleOptions}
      />
    </FriendsContainer>
  )
}

export default Friends
